export default __webpack_public_path__ + "static/hadawa_video_sp-bf9056045c648fbcf92eea85caf2d388.mp4";